/**
 * Hook for building the zone grid layout
 */

import React from 'react'
import type { Zone } from 'src/store/todo/types'
import { buildGridLayout } from '../utils/filtering'
import type { GridLayout } from '../types'

/**
 * Custom hook to build a grid layout from zones
 * Memoized to avoid rebuilding when zones haven't changed
 *
 * @param zones - Array of zones with position data
 * @returns Grid layout with 2D array and row indices
 *
 * @example
 * const { grid, rowIndices } = useGridLayout(zones)
 * // grid[colIdx][rowIdx] gives you the zone or null
 * // rowIndices tells you which row numbers have zones
 */
export const useGridLayout = (zones: Zone[]): GridLayout => {
  return React.useMemo(() => {
    return buildGridLayout(zones)
  }, [zones])
}
